export default "https://cdn-static.gokick.com/assets/7e8bc23aa9277111cd73fa77d581d1f801b67d5a/images/one-pack.d480e98fa5cc774d464fa35a18a8809f.png";